interface IImageItem{
    src: string,
    thumb: string,
    type: 'image',
    alt: string,
    args: any,
  }
export class ImageItem{
    constructor(public data:IImageItem){}
}